"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _cssClassesHelper = require("../../helpers/cssClassesHelper");
var _ComponentRowSingle = _interopRequireDefault(require("../ComponentRow/ComponentRowSingle"));
var _ActivityPageContainer = _interopRequireDefault(require("../../components/ActivityPage/ActivityPageContainer"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
var bemClasses = (0, _cssClassesHelper.getBEMClasses)('activity-page');
var ActivityPage = function ActivityPage(props) {
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(_ComponentRowSingle["default"], {
    customClass: bemClasses('row'),
    component: /*#__PURE__*/_react["default"].createElement(_ActivityPageContainer["default"], null, props.children)
  }));
};
var _default = exports["default"] = ActivityPage;